export enum PracticeSessionCardEnum {
  PAUSED = "Paused",
  COMPLETED = "Completed",
}

export enum EventTypesEnum {
  START_PRACTICE = "start_practice",
  RESUME_PRACTICE = "resume_practice",
  VIEW_QUESTION = "view_question",
  SELECT_ANSWER = "select_answer",
  INPUT_ANSWER = "input_answer",
  UPLOAD_ANSWER = "upload_answer",
  CLEAR_ANSWER = "clear_answer",
  SUBMIT_ANSWER = "submit_attempt",
  SUBMIT_SECOND_ATTEMPT = "submit_second_attempt",
  SKIP_QUESTION = "skip_question",
  NEXT_QUESTION = "next_question",
  VIEW_KSC = "view_ksc",
  VIEW_SOLUTION = "view_solution",
  MARKED_FOR_CLARIFICATION = "marked_for_clarification",
  MARKED_FOR_REVISION = "marked_for_revision",
  REPORT_ERROR_POPUP_OPEN = "report_error_popup_open",
  REPORT_ERROR_POPUP_CLOSE = "report_error_popup_close",
  SUBMIT_REPORT_ERROR = "submit_report_error",
  PAUSE_PRACTICE_POPUP_OPEN = "pause_practice_popup_open",
  PAUSE_PRACTICE_POPUP_CLOSE = "pause_practice_popup_close",
  USER_PAUSE_PRACTICE = "pause_practice",
  END_PRACTICE_POPUP_OPEN = "end_practice_popup_open",
  END_PRACTICE_POPUP_CLOSE = "end_practice_popup_close",
  SESSION_SUMMARY_POPUP_OPEN = "session_summary_popup_open",
  SESSION_SUMMARY_POPUP_CLOSE = "session_summary_popup_close",
  USER_END_PRACTICE = "user_end_practice",
  END_PRACTICE_SUCCESSFUL = "end_practice_successful",
  AUTO_END_PRACTICE = "auto_end_practice",
}

export enum QuestionStatusEnum {
  SKIPPED = "skipped",
  CORRECT = "correct",
  INCORRECT = "incorrect",
  SECOND_CORRECT = "secondCorrect",
  SECOND_INCORRECT = "secondIncorrect",
  CURRENT_QUESTION = "currentQuestion",
  SECOND_SKIPPED = "secondSkipped",
}

export enum PerformanceNudgeEnum {
  QUESTION_CORRECT = 1,
  QUESTION_INCORRECT = 2,
  WINNING_STREAK_10 = 11,
  WINNING_STREAK_5 = 12,
  LOSING_STREAK_10 = 13,
  LOSING_STREAK_5 = 14,
  SKIPPED_PERCENT_50 = 15,
  SKIPPED_PERCENT_25 = 16,
  CONCEPT_MASTERY_10_HARD = 21,
  CONCEPT_MASTERY_5_HARD = 22,
  CONCEPT_ACCURACY_HIGH = 23,
  CONCEPT_ACCURACY_LOW = 24,
  QUESTION_TOUGH_NUT_CRACKED = 31,
  QUESTION_EASY_MISSED = 32,
  QUESTION_CORRECT_AFTER_CONCEPT_VIEW = 33,
  EARN_MORE_SPEED_COINS = 41,
  EARN_SPEED_COINS = 42,
  CORRECTED_COUNT_4X = 51,
  CORRECTED_COUNT_2X = 52,
  CORRECTED_COUNT_X = 53,
  ACCURACY_VERY_LOW_SPEED_VERY_HIGH = 61,
  ACCURACY_HIGH_SPEED_HIGH = 62,
  ACCURACY_HIGH_SPEED_LOW = 63,
  ACCURACY_LOW_SPEED_HIGH = 64,
  ACCURACY_LOW_SPEED_LOW = 65,
}

export enum SelfPracticeQuestionEnum {
  ALL_QUESTIONS = 1,
  PAST_YEAR = 2,
}

export enum SelfPracticeQuestionTypeEnum {
  MIXED = 1,
  SUBJECTIVE = 2,
}
